module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/._core-js@2.4.1@core-js/library/modules/_library.js
// module id = 69
// module chunks = 0